import type { planning as Fr } from '../fr/planning';

/** « planning » in English — typed on the French: a missing sentence does not compile. */
export const planning: typeof Fr = {
  couches: {
    loue: 'Rented', reserve: 'Booked', dispo: 'Available',
    retard: 'Overdue', entretien: 'Maintenance', trou: 'Gap to sell',
  } as Record<string, string>,
  aides: {
    retard: 'otherwise shown as rented',
    entretien: 'otherwise shown as booked',
    trou: 'idle days between two rentals',
  } as Record<string, string | undefined>,
  appeler: (client: string | undefined) => `Call ${client ?? 'the customer'}`,
  paye: 'paid',
  impaye: 'unpaid',
  titre: 'Planning board',
  vehicules: (n: number) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'} ·`,
  deA: (a: string, b: string) => `from ${a} to ${b}`,
  selectionnees: (n: number) => ` · ${n} ${n === 1 ? 'vehicle' : 'vehicles'} selected`,
  ceMois: 'This month',
  mois: (n: number) => `${n} ${n === 1 ? 'month' : 'months'}`,
  nVoitures: (n: number) => `${n} ${n === 1 ? 'vehicle' : 'vehicles'}`,
  choisirVoitures: 'Choose vehicles',
  masquerQuadrillage: 'Hide the day grid',
  afficherQuadrillage: 'Show the day grid',
  masquerGrillage: 'Hide grid',
  afficherGrillage: 'Show grid',
  couleurs: 'Colours',
  voituresAffichees: 'Vehicles shown',
  toutes: 'All',
  fermer: 'Close',
  aucuneCoche: 'Nothing ticked = all vehicles. Your choice is kept for next time.',
  couleursPlanning: 'Planning board colours',
  retablir: 'Reset',
  couleursExplication: 'Three colours by default — rented, booked, available. The others switch on if you want them. A layer turned off never hides an occupied vehicle: it simply takes one of the three base colours.',
  couleurDe: (label: string) => `Colour — ${label}`,
  toujours: 'always',
  afficherCouche: (label: string) => `Show ${label}`,
  trousTitre: (n: number, m: string) => `${n} ${n === 1 ? 'gap' : 'gaps'} in the planning board — ${m} of idle money`,
  trousA: (n: number) => `${n} ${n === 1 ? 'day' : 'days'} when a vehicle sits idle `,
  entreDeux: 'between two rentals',
  trousB: '. They are hatched in orange below: the vehicle is already here, already prepared.',
  vehicule: 'Vehicle',
  trouTitre: (n: number, m: string) => `${n} free ${n === 1 ? 'day' : 'days'} between two rentals — ${m} to sell`,
  ouvrirDossier: (ref: string) => `Open file ${ref}`,
  preparation: (min: number) => `Preparation — ${min} min before the next check-out`,
  duAu: (a: string, b: string) => `From ${a} to ${b}`,
  effacer: 'Clear',
  parJour: (m: string) => `${m}/day`,
  cliquezVoiture: 'Click a vehicle to open a new rental already filled in with these dates.',
  libreLe: (d: string) => ` · available on ${d}`,
  glissez: 'Drag across the planning board',
  aideBas: ' to see what is available over a period. Red is not an error: it is a day when the vehicle earns nothing. A vehicle returning at 11:00 is not available at 11:00 — the hatched end of each bar is preparation time, and it cannot be booked.',
};
